(function () {
  // gallery: thumbs switch the main image
  var main = document.getElementById('mainimg');
  var gmain = document.getElementById('gmain');
  var thumbs = document.querySelectorAll('.thumbs button');
  thumbs.forEach(function (b) {
    b.addEventListener('click', function () {
      if (!main || !b.dataset.src) return;
      main.src = b.dataset.src;
      if (gmain) gmain.classList.toggle('photo', b.dataset.type === 'photo');
      thumbs.forEach(function (x) { x.classList.toggle('active', x === b); });
    });
  });
  // review histogram filter
  var hrows = document.querySelectorAll('.hrow');
  hrows.forEach(function (h) {
    if (h.closest('[data-shared-reviews]')) return;
    h.addEventListener('click', function () {
      var wasActive = h.classList.contains('active');
      hrows.forEach(function (x) { x.classList.remove('active'); });
      if (!wasActive) h.classList.add('active');
      var show = wasActive ? null : h.getAttribute('data-rating');
      document.querySelectorAll('.rrow').forEach(function (row) {
        row.hidden = show !== null && row.getAttribute('data-rating') !== show;
      });
    });
  });
})();
;
(function () {
    var CIRC = '<svg class="circ" viewBox="0 0 300 80" preserveAspectRatio="none" aria-hidden="true">' +
      '<path pathLength="1" d="M297,11 C262,1 92,2 39,18 C4,30 1,50 45,63 C96,77 216,79 265,64 C295,54 299,38 268,25 C247,17 200,13 160,12"/></svg>';
    document.querySelectorAll('em').forEach(function (el) {
      if (!el.querySelector('.circ')) el.insertAdjacentHTML('beforeend', CIRC);
    });
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('drawn'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('em').forEach(function (el) { obs.observe(el); });
    document.querySelectorAll('.acc2 > button').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.parentElement.classList.toggle('open');
        b.querySelector('i').textContent = open ? '−' : '+';
      });
    });
  })();
;
(function () {
  var BASE = [
    ['M', 297, 11], ['C', 262, 1, 92, 2, 39, 18], ['C', 4, 30, 1, 50, 45, 63],
    ['C', 96, 77, 216, 79, 265, 64], ['C', 295, 54, 299, 38, 268, 25],
    ['C', 247, 17, 200, 13, 160, 12]
  ];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rebuild(svg) {
    var w = svg.clientWidth || svg.getBoundingClientRect().width;
    var h = svg.clientHeight || svg.getBoundingClientRect().height;
    if (!w || !h) return;
    var sx = w / 300, sy = h / 80;
    var d = BASE.map(function (seg) {
      var cmd = seg[0], out = [cmd];
      for (var i = 1; i < seg.length; i += 2) {
        out.push((seg[i] * sx).toFixed(1) + ',' + (seg[i + 1] * sy).toFixed(1));
      }
      return out.join(' ');
    }).join(' ');
    svg.setAttribute('viewBox', '0 0 ' + w.toFixed(0) + ' ' + h.toFixed(0));
    svg.removeAttribute('preserveAspectRatio');
    var path = svg.querySelector('path');
    path.removeAttribute('pathLength');
    path.setAttribute('d', d);
    path.style.vectorEffect = 'none';
    var len = path.getTotalLength();
    path.style.strokeDasharray = len;
    path.style.strokeDashoffset = reduce ? 0 : len;
    return path;
  }

  function start() {
    var rings = [];
    document.querySelectorAll('svg.circ').forEach(function (svg) {
      var path = rebuild(svg);
      if (path) rings.push({ svg: svg, path: path });
    });
    run(rings);
  }

  function run(rings) {
    if (reduce || !rings.length) return;

    function draw(r) {
      r.path.style.transition = 'stroke-dashoffset 0.9s cubic-bezier(0.65, 0, 0.35, 1) 0.1s';
      r.path.style.strokeDashoffset = 0;
    }
    if (!('IntersectionObserver' in window)) { rings.forEach(draw); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var hit = rings.find(function (r) { return r.svg === en.target; });
        if (hit) { draw(hit); io.unobserve(en.target); }
      });
    }, { threshold: 0.5 });
    rings.forEach(function (r) { io.observe(r.svg); });
  }

  // measure only after the embedded fonts have laid out, or the ellipse is
  // built against pre-font metrics and gets stretched by the reflow. Timers
  // rather than requestAnimationFrame: rAF never fires in a hidden tab.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { setTimeout(start, 60); });
  } else {
    window.addEventListener('load', function () { setTimeout(start, 60); });
  }
})();
(function () {
  var form = document.getElementById('skopos-atc-form');
  if (!form) return;
  var requested = new URLSearchParams(location.search).get('finish');
  var links = Array.from(document.querySelectorAll('.swatches a[data-name]'));
  var match = links.find(function (link) { return link.dataset.name === requested; });
  if (match && new URL(match.href).pathname !== location.pathname) {
    location.replace(match.href);
    return;
  }
  var tiers = Array.from(document.querySelectorAll('.tiers .tier'));
  var button = form.querySelector('[type="submit"]');
  var error = document.getElementById('skopos-cart-error');
  var bundle = false;
  var tierGroup = document.querySelector('.tiers');
  var unitPrice = Number(tierGroup.dataset.unitPrice);
  var currency = tierGroup.dataset.currency;
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:currency,minimumFractionDigits:cents%100?2:0,maximumFractionDigits:2}).format(cents/100);
  }
  function renderTierPrices() {
    if (!Number.isFinite(unitPrice) || unitPrice <= 0) return;
    var rewardActive = ['active','ready'].includes(window.SkoposReward?.state?.kind);
    var selections = Array.from(document.querySelectorAll('.psel'));
    var selectedPrices = selections.map(function(select){return Number(select.selectedOptions[0]?.dataset.price)||unitPrice;});
    var originalBundle = selectedPrices.reduce(function(sum,price){return sum+price;},0);
    var payableBundle = originalBundle - Math.min.apply(null,selectedPrices);
    tiers.forEach(function(tier) {
      var count = tier.dataset.label === '3 pairs' ? 3 : 1;
      var original = count === 3 ? originalBundle : unitPrice;
      var total = count === 3 ? payableBundle : unitPrice;
      if(rewardActive)total -= Math.round(total * .2);
      var strike = tier.querySelector('[data-tier-original]');
      strike.textContent = money(Math.round(original/count));
      strike.hidden = original <= total;
      tier.querySelector('[data-tier-unit]').textContent = money(Math.round(total/count));
      tier.dataset.price = money(total);
    });
    var active = tiers.find(function(tier){return tier.classList.contains('active');});
    if(active){var price=button.querySelector('.bprice');if(price)price.textContent=active.dataset.price;}
  }
  document.addEventListener('skopos:reward-state',renderTierPrices);
  document.querySelectorAll('.psel').forEach(function(select){select.addEventListener('change',renderTierPrices);});
  renderTierPrices();
  function selectTier(tier) {
    bundle = tier.dataset.label === '3 pairs';
    tiers.forEach(function (item) {
      item.classList.toggle('active', item === tier);
      item.setAttribute('aria-pressed', String(item === tier));
    });
    var price = button.querySelector('.bprice');
    if (price) price.textContent = tier.dataset.price;
  }
  tiers.forEach(function (tier) {
    tier.addEventListener('click', function () { selectTier(tier); });
    tier.addEventListener('keydown', function (event) {
      if (event.target === tier && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault(); selectTier(tier);
      }
    });
  });
  form.addEventListener('submit', async function (event) {

    event.preventDefault();
    if (button.disabled) return;
    button.disabled = true;
    error.hidden = true;
    try {
      var quantities = new Map();
      if (!bundle) quantities.set(form.querySelector('[name="id"]').value,Number(form.querySelector('[name="quantity"]').value)||1);
      if (bundle) document.querySelectorAll('.psel').forEach(function (select) {
        if (!select.value) throw new Error('Please choose an available finish for each pair.');
        quantities.set(select.value, (quantities.get(select.value) || 0) + 1);
      });
      var properties={};
      new FormData(form).forEach(function(value,name){
        if(name.startsWith('properties[') && name.endsWith(']')) properties[name.slice(11,-1)]=value;
      });
      var items=Array.from(quantities,function(entry){return {id:Number(entry[0]),quantity:entry[1],properties:properties};});
      if (window.SkoposCart) await window.SkoposCart.add(items);
      else {
        var response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})});
        var result=await response.json();
        if(!response.ok) throw new Error(result.description || 'Unable to add these items.');
        location.assign(window.Shopify.routes.root+'cart');
      }
      button.disabled=false;
    } catch (failure) {
      error.textContent = failure.message;
      error.hidden = false;
      button.disabled = false;
    }
  });
})();
